import { render, staticRenderFns } from "./Login-Carousel.vue?vue&type=template&id=98f48e0e&scoped=true&"
import script from "./Login-Carousel.vue?vue&type=script&lang=js&"
export * from "./Login-Carousel.vue?vue&type=script&lang=js&"
import style0 from "./Login-Carousel.vue?vue&type=style&index=0&id=98f48e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f48e0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCarousel,VCarouselItem,VIcon,VImg})
